import { Component } from '@angular/core';
import { SafePipe } from 'src/app/pipes/safe.pipe';

@Component({
  selector: 'app-chat',
  imports: [SafePipe],
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.scss'
})
export class ChatComponent {
  chatUrl: string = "https://uman.dev.cad42.com"
}
